import { watch } from 'vue'
import { rbacPermissionNames } from '@/utils/rbacStore'
import { hasPermission, hasAnyPermission } from '@/utils/rbac'

/**
 * v-permission 指令：无权限时隐藏 DOM（display:none）
 * 用法：v-permission="'创建活动'" 或 v-permission="['创建活动','编辑活动']"（任一即可）
 */
function applyPermissionVisibility (el, binding) {
  const val = binding.value
  if (val == null || val === '') {
    el.style.display = ''
    return
  }
  const names = rbacPermissionNames.value
  const ok = Array.isArray(val)
    ? hasAnyPermission(names, val)
    : hasPermission(names, val)
  el.style.display = ok ? '' : 'none'
}

export const vPermission = {
  mounted (el, binding) {
    applyPermissionVisibility(el, binding)
    el._rbacStopWatch = watch(
      rbacPermissionNames,
      () => applyPermissionVisibility(el, binding),
      { deep: true }
    )
  },
  updated (el, binding) {
    applyPermissionVisibility(el, binding)
  },
  unmounted (el) {
    el._rbacStopWatch?.()
    delete el._rbacStopWatch
  }
}
